import { loadStripe } from '@stripe/stripe-js/pure';
import { Controller } from 'stimulus';
import '../css/stripe.css';
export default class default_1 extends Controller {
    static values = { apiPublicKey: String, clientSecret: String, successUrl: String };
    static targets = ['payButton', 'codeElement', 'paymentError', 'spinner', 'buttonText', 'resultMessage'];
    async connect() {
        this.stripe = await loadStripe(this.apiPublicKeyValue);
        console.log(this.successUrlValue);
        if (!this.stripe) {
            throw 'Unable to load Stripe library';
        }
        this.payButtonTarget.disabled = true;
        this.codeElementTarget.addEventListener('change', (event) => {
            const input = event.target;
            const isEmpty = input?.value === '';
            this.payButtonTarget.disabled = isEmpty;
            if (!isEmpty) {
                this.paymentErrorTarget.textContent = '';
            }
        });
    }
    payBlik(event) {
        event.preventDefault();
        this.showSpinnerOnPaymentSubmission();
        this.stripe?.confirmBlikPayment(this.clientSecretValue, {
            payment_method: {
                blik: {},
            },
            payment_method_options: {
                blik: {
                    code: this.codeElementTarget.value,
                },
            },
        }).then((result) => {
            if (result.error) {
                this.showCustomerErrorOnChargeFailure(result.error.message);
            }
            else {
                this.showSuccessMessageOnCompletePayment(result.paymentIntent?.id);
            }
        });
    }
    showSpinnerOnPaymentSubmission() {
        this.payButtonTarget.disabled = true;
        this.showElement(this.spinnerTarget);
        this.hideElement(this.buttonTextTarget);
    }
    hideSpinner() {
        this.payButtonTarget.disabled = false;
        this.hideElement(this.spinnerTarget);
        this.showElement(this.buttonTextTarget);
    }
    showCustomerErrorOnChargeFailure(errorMessage) {
        this.hideSpinner();
        this.paymentErrorTarget.textContent = errorMessage;
        this.showElement(this.paymentErrorTarget);
        setTimeout(() => {
            this.paymentErrorTarget.textContent = '';
            this.hideElement(this.paymentErrorTarget);
        }, 4000);
    }
    hideElement(...items) {
        items.forEach((item) => item.classList.add('hidden'));
    }
    showElement(...items) {
        items.forEach((item) => item.classList.remove('hidden'));
    }
    showSuccessMessageOnCompletePayment(paymentIntentId) {
        this.hideSpinner();
        if (process.env.NODE_ENV !== 'production') {
            this.resultMessageTarget
                .querySelector('a')
                ?.setAttribute('href', `https://dashboard.stripe.com/test/payments/${paymentIntentId}`);
        }
        this.showElement(this.resultMessageTarget);
        this.payButtonTarget.disabled = true;
        setTimeout(() => {
            location.href = this.successUrlValue;
        }, 1500);
    }
}
